import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = () => {
  // Check for accessToken in sessionStorage
  const token = sessionStorage.getItem("token");

  // If no token, redirect to login page (/)
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // If token exists, render child routes (under /app)
  return <Outlet />;
};

export default ProtectedRoute;
